<!----------------------- Компонент маленького модального вікна --------------------->
<template>
  <portal to="modal">
    <div class="modal-lair" @click.stop>
      <div class="modal-container">
        <slot></slot>
      </div>
    </div>
  </portal>
</template>

<script>

import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами

export default {
  mounted() {
    // При монтуванні вимикаємо старі обробники події 'esc'
    keyevent.$off('esc');
    // Підписуємося на подію 'esc' і емітимо локальну подію 'escape'
    keyevent.$on('esc', () =>
      this.$emit('escape')
    );
  },
}
</script>

<style>
.modal-lair {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  /* блюр для модалок */
  backdrop-filter: blur(5px);
  background: rgb(200 200 200 / 70%);
}

.modal-container {
  min-width: 330px;
  background: #ffffff;
  /* width: 50%; */
  padding: 15px;
  border-radius: 7px;
}

@media screen and (max-width: 340px) {
  .modal-container {
    min-width: auto;
  }
}

@media screen and (max-width: 550px) {
  .modal-container {
    width: 90%;
  }
}
</style>
